<app-third-party-login-header></app-third-party-login-header>
<div class="go-back-btn psic-gap-2" (click)="goBack()">
    <mat-icon [svgIcon]="'back'" class="back-icon"></mat-icon>
    <span class="go-back">Go back</span>
</div>
<ng-container>
    <app-route-page>
        <div class="contact-us-content d-flex mt-md-5 align-items-center flex-md-row flex-column">
            <img
                class="col-md-6 col-12 contact-img"
                [src]="'../../../../assets/images/contact-us-image.svg'"
                [alt]="'contact-us-image'"
            />
            <div class="d-flex col-md-6 col-12 flex-column required-container">
                <h2 class="text-start">Contact Us</h2>
                <p class="caption psic-mb-2">
                    Having trouble finding the policy? Please leave us a message about your issue.
                </p>
                <form [formGroup]="form" class="d-flex flex-column psic-gap-4 w-100">
                    <div>
                        <lib-input-text [field]="emailField" formControlName="email"></lib-input-text>
                        @if (form.get('email')?.invalid && form.get('email')?.touched) {
                        <div class="text-danger small mt-1">
                            @if (form.get('email')?.errors?.['required']) {
                            <span>Email is required.</span>
                            } @if (form.get('email')?.errors?.['email']) {
                            <span>Please enter a valid email address.</span>
                            }
                        </div>
                        }
                    </div>
                    <div>
                        <lib-input-text [field]="phoneField" formControlName="phone"></lib-input-text>

                        @if (form.get('phone')?.invalid && form.get('phone')?.touched) {
                        <div class="text-danger small mt-1">
                            @if (form.get('phone')?.errors?.['required']) {
                            <span>Phone number is required.</span>
                            } @if (form.get('phone')?.errors?.['pattern']) {
                            <span>Please enter a valid phone number.</span>
                            }
                        </div>
                        }
                    </div>
                    <div class="d-flex flex-column psic-gap-1">
                        <!-- <label class="caption-bold">Describe the issue</label> -->
                        <!-- <p class="caption">Including your full name, policy number, and your interest in the policy</p> -->

                        <mat-form-field
                            class="dynamic-textarea-field w-100"
                            appearance="fill"
                            floatLabel="always"
                            subscriptSizing="dynamic"
                            hideRequiredMarker
                        >
                            <mat-label>{{ descriptionField.caption }}</mat-label>
                            <textarea
                                matInput
                                class="caption"
                                style="resize: none; min-height: 80px"
                                rows="4"
                                [id]="descriptionField.id"
                                [placeholder]="descriptionField.placeholder"
                                [maxlength]="descriptionField.maxLength || null"
                                [readonly]="descriptionField.readonly"
                                formControlName="description"
                            ></textarea>
                            <mat-hint align="start" class="disclaimer psic-mt-1">
                                {{ getRemainingCharacters(descriptionField) }} of
                                {{ descriptionField.maxLength || 0 }} characters left
                            </mat-hint>
                        </mat-form-field>
                        @if (form.get('description')?.invalid && form.get('description')?.touched) {
                        <div class="text-danger small mt-1">
                            @if (form.get('description')?.errors?.['required']) {
                            <span>Description is required.</span>
                            }
                        </div>
                        }
                    </div>
                    <lib-button
                        (callback)="onSubmit()"
                        buttonText="Submit"
                        [disabled]="!form.valid || isLoading"
                    ></lib-button>
                </form>
            </div>
        </div>
    </app-route-page>
</ng-container>
